export const classicLightTheme = {
    id: 'classic-light',
    label: 'Classic Light',
    description: 'The original ATLAS light palette.',
    paletteMode: 'light',
    tokens: {
        app: { bg: '#f1f5f9', bgElevated: '#ffffff' },
        surface: {
            nav: '#ffffff',
            panel: '#ffffff',
            panelAlt: '#f8fafc',
            input: '#ffffff',
        },
        border: {
            default: '#e5e7eb',
            strong: 'rgba(79, 70, 229, 0.50)',
        },
        text: {
            primary: '#0f172a',
            secondary: '#475569',
            disabled: '#94a3b8',
            inverse: '#ffffff',
        },
        action: {
            primary: '#4f46e5',
            primaryHover: '#4338ca',
            secondary: '#7c3aed',
        },
        state: {
            success: '#059669',
            warning: '#d97706',
            error: '#dc2626',
            info: '#0891b2',
        },
        data: {
            seriesA: '#4f46e5',
            seriesB: '#7c3aed',
            seriesC: '#059669',
            seriesD: '#d97706',
        },
        effect: {
            glow: 'rgba(79, 70, 229, 0.20)',
            shadow: '0 4px 12px -2px rgb(0 0 0 / 0.12), 0 2px 6px -2px rgb(0 0 0 / 0.08)',
        },
    },
};
//# sourceMappingURL=classic-light.js.map